import React, { FC } from 'react';
import { useTranslate } from '@tolgee/react';
import ImageCard from '../cards/imageCard';
import { lomavisShowToastr } from '../../../../../../utils/ui/toastr';
import { MAX_MEDIA_FILES } from '../../../../config/constants';
import { useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../../pages/lomavisCreator';
import { ALL } from '../../../../../../config/constants';

interface Props {
  mediaUrls: string[];
  selectedMedia: any[];
  setSelectedMedia: React.Dispatch<React.SetStateAction<any[]>>;
}

const PluginMedia: FC<Props> = ({
  mediaUrls,
  selectedMedia,
  setSelectedMedia
}) => {
  const { t } = useTranslate();
  const postDataMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[ALL]?.media
  );

  const updateMediaSelection = (value: string) => {
    setSelectedMedia((prev) => {
      if (prev.includes(value)) {
        // Remove value
        return prev.filter((item) => item !== value);
      } else {
        if (prev.length + postDataMediaFiles?.length >= MAX_MEDIA_FILES) {
          lomavisShowToastr(
            t('lomavisCreator.pluginMedia.error.maxSelect'),
            'error'
          );

          return prev; // No update
        }
        return [...prev, value];
      }
    });
  };

  return (
    <div style={{ overflowY: 'auto' }} className="w-100 d-flex gap-2 flex-wrap">
      {mediaUrls?.length > 0 ? (
        mediaUrls?.map((item) => (
          <div className={`px-3 py-3 `}>
            <ImageCard
              imageUrl={item}
              selected={selectedMedia.includes(item)}
              selectImage={updateMediaSelection}
            />
          </div>
        ))
      ) : (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          {t('lomavisCreator.mediaAltTags.emptyMedia')}
        </div>
      )}
    </div>
  );
};

export default PluginMedia;
